export const ISO_DATE_FORMAT = 'YYYY-MM-DD';

export enum DATE_PART {
    day = 'DD',
    month = 'MM',
    year = 'YYYY'
}
